import Button from "@mui/material/Button";
import { useLocalStorageState } from "hooks/useLocalStorageState";

import { useVendorDashboardEnabled } from "./useVendorDashboardEnabled";

export const VENDOR_DASHBOARD_STORAGE_KEY = "waste-manifests-vendor-dashboard-open";

export function VendorDashboardToggle() {
  // Same gate the dashboard itself uses, so the toggle and the section it
  // opens can never disagree.
  const enabled = useVendorDashboardEnabled();

  const [open, setOpen] = useLocalStorageState<boolean>(VENDOR_DASHBOARD_STORAGE_KEY, {
    defaultValue: true,
  });

  if (!enabled) {
    return null;
  }

  return (
    <Button onClick={() => setOpen(!open)} variant="text">
      {open ? "Hide Vendor Stats" : "Show Vendor Stats"}
    </Button>
  );
}
